import React from "react";
import { Modal } from "react-bootstrap";

const ValideDialog = ({
  isValideDialogOpen,
  setIsValideDialogOpen,
  handleDeleteConfirm,
  message,
}) => {
  return (
    <Modal
      show={isValideDialogOpen}
      onHide={() => setIsValideDialogOpen(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message || "Are you sure you want to delete this item?"}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => setIsValideDialogOpen(false)}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={() => {
            handleDeleteConfirm();
            setIsValideDialogOpen(false);
          }}
        >
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ValideDialog;
